// Computed data for charts
export const getLeadsByClient = (clients) => {
    return clients.map((agent) => ({
      name: agent.client_name,
      leads: agent.total_leads,
    }));
  };
  
  export const getLeadsByProperty = (properties) => {
    return properties.map((property) => ({
      name: property.property_name,
      leads: property.total_leads,
    }));
  };
  
  export const getLeadScoreDistribution = (score_distribution) => {

    return [
      { name: "Cold", value: score_distribution.cold, fill: "#6b7280" },
      { name: "Warm", value: score_distribution.warm, fill: "#f59e0b" },
      { name: "Hot", value: score_distribution.hot, fill: "#ef4444" },
    ];
  };
  

export const getWeeklyLeadsTrend = (weekly) => {
    return weekly.map((week) => ({
      name: week.label,
      leads: week.count,
    }));
  };
export const getMonthlyLeadsTrend = (monthly) => {
    return monthly.map((month) => ({
      name: month.label,
      leads: month.count,
    }));
  };
export const getDailyLeadsTrend = (daily) => {
    return daily.map((day) => ({
      name: day.label,
      leads: day.count,
    }));
  };